import { List } from 'immutable';
import { leadFilterConstants } from '../constants';

export function lead_filters(state = {}, action) {
  switch (action.type) {
    case leadFilterConstants.LEAD_FILTER_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case leadFilterConstants.LEAD_FILTER_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case leadFilterConstants.LEAD_FILTER_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case leadFilterConstants.LEAD_FILTER_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case leadFilterConstants.LEAD_FILTER_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case leadFilterConstants.LEAD_FILTER_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case leadFilterConstants.LEAD_FILTER_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case leadFilterConstants.LEAD_FILTER_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const leadFilterIndex = state.items.findIndex(val => val.id == action.response.id);

      if (leadFilterIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(leadFilterIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case leadFilterConstants.LEAD_FILTER_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case leadFilterConstants.LEAD_FILTER_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case leadFilterConstants.LEAD_FILTER_DELETE_SUCCESS: {
      const { leadFilterId } = action;

      if (!state.items) {
        return state;
      }

      const leadFilterIndex = state.items.findIndex(val => val.id == leadFilterId);

      if (leadFilterIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(leadFilterIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case leadFilterConstants.LEAD_FILTER_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case leadFilterConstants.LEAD_FILTER_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
